import { MIDDLEWARE_URL as BASE_URL } from "../request";
import constants from "../CRUD/constants";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../CRUD/utils";

const MIN_DAYS_IN_ARI_MANAGER = 14;
const MAX_DAYS_IN_ARI_MANAGER = 31;

const ModuleDefinition = {
  name: "Configuration Manager",
  entityName: constants.ENTITY.CONFIGURATION_MANAGER.name,
  restConfig: {
    baseURL: `${BASE_URL}`,
    fetch: {
      url: ({ hotelTicker }) =>
        `WitBookerAPI-war/webresources/endpoint/establishment/${hotelTicker}/configurations`,
      method: "get",
    },
    update: {
      url: ({ hotelTicker }) =>
        `WitBookerAPI-war/webresources/endpoint/establishment/${hotelTicker}/createOrUpdateConfigurations`,
      method: "get",
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "Traducciones",
    widget: "translations",
    entityProperty: "translations",
  },
  fields: {
    list: [],
    form: [
      {
        fieldName: "showNewBookingForm",
        displayName: "New booking form",
        widget: "checkbox",
        description: "Use new booking form",
        defaultValue: false,
      },
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        widget: "checkbox",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
        defaultValue: false,
      },
      {
        fieldName: "hasOneRateChild",
        displayName: "hasOneRateChild",
        description:
          "En caso que el hotel maneje ocupaciones de sólo niños y bebes ( sin juniors) y los bebés no tengan tarifa (precio cero), debe notificarse a Witbooking para configurarse el parámetro.",
        widget: "checkbox",
        helpText:
          "NOTA: si useCustomChildConfiguration está activo, hasOneRateChild  debe estar desactivado, no pueden convivir.",
        defaultValue: false,
      },
      {
        fieldName: "useCustomChildConfiguration",
        displayName: "useCustomChildConfiguration",
        description:
          "(SOLO DINGUS) En caso de que el cliente maneje distintas ocupaciones de niños (bebés / niños / juniors), y envíen precios utilizando los parámetros CHILD_A y CHILD_B, se debe activar el parámetro.",
        helpText:
          "NOTA: si hasOneRateChild está activo, useCustomChildConfiguration debe estar desactivado, no pueden convivir.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "compoundDiscounts",
        displayName: "Descuentos compuestos",
        description:
          "Determina si al acumularse descuentos sus porcentajes se multiplican (activo) o se suman (desactivado)",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "hasPremiumMap",
        displayName: "Mapa premium",
        description: "Activar solo bajo petición y aprobación del board",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showNewReservationsList",
        displayName: "Nuevo listado de reservas",
        description:
          "Reemplazar el actual listado de reservas por el nuevo, tanto el básico como el ampliado",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showCancellationTable",
        displayName: "Restricciones Cancelación",
        description:
          "Mostrar tabla de restricciones de cancelación en email de confirmación/cancelación plantilla default",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showHistoricalReservations",
        displayName: "Historical Reservation",
        widget: "checkbox",
        defaultValue: false,
        description: "Activate Historical Reservation Button",
      },
      {
        displayName: "Custom domain",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "customDomainProtocol",
        displayName: "Protocolo",
        widget: "selector",
        optionDisplay: {
          http: {
            label: "http",
          },
          https: {
            label: "https",
          },
        },
        defaultValue: "https",
      },
      {
        fieldName: "customDomain",
        displayName: "Dominio",
        helpText: "Al introducir un dominio el motor redirigirá a este",
        widget: "input",
      },
      {
        fieldName: "mailSenderAddress",
        displayName: "Email custom",
        helpText: "Dirección de email que se usará para enviar los correos de la propiedad",
        widget: "input",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activar campo CCV para PCIProxy",
        widget: "checkbox",
        description: "Activates the CCV Field for the PCIProxy payment type",
        helpText:
          "Currently only works for PCI Proxy, could be expanded to other payment types in the future",
        defaultValue: false,
      },
      {
        fieldName: "showOccupationAlternativesManager",
        displayName: "Activar alternativas de ocupación",
        widget: "checkbox",
        description:
          "Se activará el desplegable para configurar si mostrar alternativas de ocupación en Comportamiento",
        defaultValue: false,
      },
      {
        fieldName: "allowMultipleMealPlans",
        displayName: "Permitir distintas pensiones en reservas multiples.",
        widget: "checkbox",
        description:
          "Si se desactiva El motor NO permitirá añadir al carrito líneas con pensiones diferentes.",
        defaultValue: true,
      },
      {
        fieldName: "hideInventoriesFilteredByOccupation",
        widget: "hidden",
        defaultValue: false,
      },
      {
        displayName: "Gestores",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "showEmailTemplateManager",
        description: "Emails personalizados",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showAdvancedEmailsManager",
        description:
          "Nuevo gestor de email pre/post/configuración (si esta en true solo habilita la visualizacion del nuevo gestor, no tiene nada que ver con la logica de envios)",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "newEmailConfig",
        description:
          "Nuevo envío de email pre/post/configuración (si esta en true habilitar el envio nuevo desde el api y si no realizara el envio antiguo desde el middleware)",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showDisplayManager",
        description: "Display",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showAdvancedConditionsManagers",
        description: "Condiciones avanzadas",
        helpText: "Condiciones / Formas de cobro / Políticas de cancelación",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showAdvancedMealplanManagers",
        description: "Pensiones",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showPromotionsManager",
        description: "Destacados / Promociones",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showServicesManager",
        description: "Servicios/Extras",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "numberOfPromotionsGroup",
        displayName: "Número de grupos en las promociones",
        widget: "selector",
        optionDisplay: {
          1: {
            label: "1",
          },
          2: {
            label: "2",
          },
          3: {
            label: "3",
          },
          4: {
            label: "4",
          },
          5: {
            label: "5",
          },
          6: {
            label: "6",
          },
          7: {
            label: "7",
          },
          8: {
            label: "8",
          },
          9: {
            label: "9",
          },
          10: {
            label: "10",
          },
        },
        defaultValue: 1,
      },
      {
        fieldName: "showFiltersManager",
        description: "Filtros",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showPackagesManager",
        description: "Paquetes",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showAccommodationsManager",
        description: "Nuevo gestor de Alojamientos",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showNewReservationModification",
        description: "Modificación de reservas",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showInventoryMultiUpdate",
        description: "Cargar excel inventarios",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showInventoryTable",
        description: "Tabla de inventario",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "showBatchInventories",
        description: "Crear líneas de inventarios por lotes",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "enableAutomaticCharges",
        description: "Habilitar configuración de cobro automático según política de cancelación",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "propertyImageLimit",
        displayName:
          "Límite de imágenes en Info establecimiento. Indicar el número máximo de imágenes que se permiten cargar",
        widget: "input",
        defaultValue: 20,
      },
      {
        fieldName: "stickyBookingForm",
        displayName: "Visualización Booking Form",
        description: "Booking form del motor en formato sticky",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "allowCustomerCommentEdit",
        displayName: "Modificación de reserva",
        description: "Activar edicion comentarios cliente en Backoffice",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Activar cancelación por lotes ",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "showBatchCancellation",
        description:
          "Se activará el botón en el listado de reserva para redirigir al gestor de cancelación por lote (excel)",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Channel managers",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "reservationIdType",
        displayName: "Formato de Identificador de reserva",
        description:
          "Al enviar al channel define si usar formato simple (MXXXXXX) o extendido (MXXXXXX-XXXXX)",
        widget: "selector",
        optionDisplay: {
          AUTO: {
            label: "Automático (proxies envian extendido, no proxies envian simple)",
          },
          SIMPLE: {
            label: "Simple",
          },
          EXTENDED: {
            label: "Extendido",
          },
        },
        defaultValue: "AUTO",
      },
      {
        fieldName: "roomStayIdType",
        displayName: "Formato de Identificador de roomStay",
        description:
          "(SOLO DERBYSOFT) Define si el identificador P del roomStay usa formato simple (PXXXXXX) o extendido (PXXXXXX-XXXXX)",
        helpText:
          "Derbysoft exige que la P sea única entre todos sus clientes, para lo cual debe usarse el formato extendido. Mientras no se seleccione ningún valor no se guarda nada y el backend asume Simple.",
        widget: "selector",
        optionDisplay: {
          SIMPLE: {
            label: "Simple",
          },
          EXTENDED: {
            label: "Extendido",
          },
        },
      },
      {
        fieldName: "useFullRatesChMg",
        displayName: "Enviar tarifas completas.",
        description:
          "Define que cosas se incluyen/excluyen en el desglose de tarifas diario del XML enviado a los Channel Managers",
        widget: "selector",
        optionDisplay: {
          0: {
            label: "Excluir todo (tarifas base)",
          },
          1: {
            label: "Incluir Extras y Descuentos",
          },
          2: {
            label: "Incluir sólo Descuentos",
          },
          3: {
            label: "Incluir sólo Extras",
          },
        },
        defaultValue: "1",
      },
      {
        fieldName: "sendChildInvChMg",
        displayName: "Enviar líneas hijas",
        description:
          "(SOLO Channels tipo OTA) Al activarse, al reservar una línea compartida, al Channel se envía la línea de inventario hija en vez de la madre.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "splitReservationQuantityAsRoomStays",
        displayName: "División de reservas",
        description:
          "(SOLO Channels tipo OTA) Al activarse se dividen las reservas múltiples en reservas individuales a nivel de API",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "strictUpdates",
        displayName: "Actualización de lineas hijas",
        description:
          "(SOLO Channels tipo OTA) Al activarse devuelve errores al channel manager si se actualizan lineas hijas",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "roomStaysAsOtaReservations",
        displayName: "roomStaysAsOtaReservations",
        description: "(SOLO YIELDPLANET) Dividir reservas con multiples roomStays a nivel de XML.",
        widget: "checkbox",
        helpText:
          "Al activar este param al enviarse al channel una Reserva con multiples Roomstays, en vez de enviar un array de roomstays dentro de un solo nodo HotelReservation, se envían múltiples nodos de HotelReservation, cada uno con una roomstay",
        defaultValue: false,
      },
      {
        fieldName: "detailedExtraInformation",
        displayName: "detailedExtraInformation",
        description:
          "(TODOS EXCEPTO DINGUS) Enviar informacion detallada del pricing y los dias seleccionados para un extra en el XML en el nodo Services.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "commentsInGlobalInfo",
        displayName: "commentsInGlobalInfo",
        description:
          "(TODOS EXCEPTO DINGUS) Colocar los comentarios sólo una vez en el XML en el campo ResGlobalInfo, en vez de hacerlo múltiples veces por cada RoomStay.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "sendCombinedBookingDetailedInfo",
        displayName: "sendCombinedBookingDetailedInfo",
        description:
          "(TODOS EXCEPTO DINGUS) Para aquellas reservas con tarifas combinadas se añade en el XML un comentario en formato JSON con el detalle por día de tarifa combinada ",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "sendFailedChannelNotificationToClient",
        displayName: "sendFailedChannelNotificationToClient",
        description:
          "(TODOS EXCEPTO DINGUS) Activa el envío de emails de alertas de fallos en la integración de reservas. Las alertas se enviarán a los receptores del mail de confirmación configurados en el BO.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "hardcodeTestCreditCardData",
        displayName: "hardcodeTestCreditCardData",
        description:
          "(SOLO PARA SELENTA CON TMS COMO PMS) (NO FUNCIONA SI EL METODO DE PAGO ES PROXY) Se enviarán en el XML datos de tarjeta falsas para compensar un fallo de TMS",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "sendPaymentTransactionToChannel",
        displayName: "sendPaymentTransactionToChannel",
        description:
          "(TODOS EXCEPTO DINGUS) Al activarse se envia un comentario adicional en el XML con el listado de todas las transacciones de pago realizadas en la reserva en formato JSON.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "useResilienceReservationStateMachine",
        displayName: "Resiliencia",
        description: "Activar el modulo de resiliencia",
        helpText:
          "El módulo de resiliencia evita que hayan fallos en las acciones posteriores a la creación de la reserva.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "notifyAvailabilityCheckToEngine",
        displayName: "Alertas",
        description: "Enviar alertas no integradas por falta de disponibilidad pero cobradas",
        helpText: "",
        widget: "checkbox",
        defaultValue: true,
      },
      {
        displayName: "Fideltour",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "fideltourIntegrationCode",
        displayName: "Código de integración de fideltour",
        helpText: "Identificador único asociado a un grupo hotelero proporcionado por Fideltour",
        widget: "input",
      },
      {
        displayName: "Transfer and Experiences",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "transferExpSupportedExtras",
        displayName: "Transfer and Experiences supported extras",
        helpText:
          "Listado de extras separados por comas, que al estar presentes en la reserva, permiten que esta se envíe a Transfer and Experiences",
        widget: "input",
      },
      {
        displayName: "Flexmyroom",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "flexmyroomPropertySecret",
        displayName: "Flexmyroom property secret",
        helpText:
          "Clave de encriptación proporcionado por Flexmyroom para encriptar las comunicaciones",
        widget: "input",
      },
      {
        fieldName: "flexmyroomEstablishmentId",
        displayName: "Flexmyroom establishment id",
        helpText:
          "Identificador único asociado a este establecimiento proporcionado por Flexmyroom",
        widget: "input",
      },
      {
        displayName: "BeSafe",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "besafeIntegrationUsername",
        displayName: "BeSafe Integration Username",
        helpText: "Usuario proporcionado por BeSafe para securizar las comunicaciones",
        widget: "input",
      },
      {
        fieldName: "besafeIntegrationPassword",
        displayName: "BeSafe Integration Password",
        helpText: "Password proporcionado por BeSafe para securizar las comunicaciones",
        widget: "input",
      },
      {
        displayName: "Hotelverse",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "hotelverseSubscriptionKey",
        displayName: "Hotelverse subscription key",
        helpText: "Provista por hotelverse",
        widget: "input",
      },
      {
        fieldName: "hotelverseClientId",
        displayName: "Hotelverse client id",
        helpText: "Provisto por hotelverse. Identificador interno de HV.",
        widget: "input",
      },
      {
        fieldName: "hotelverseHotelId",
        displayName: "Hotelverse hotel id",
        helpText: "Provisto por hotelverse. Identificador interno de HV.",
        widget: "input",
      },
      {
        fieldName: "hotelVerseActive",
        widget: "checkbox",
        description: "Activar HotelVerse",
        defaultValue: false,
      },
      {
        displayName: "Ulyses Cloud",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "ulysesCloudClientName",
        displayName: "Ulyses Cloud - Nombre del cliente",
        helpText: "Nombre de cliente en el dominio: <i>publicapi-{nombre}.ulysescloud.com</i>",
        widget: "input",
      },
      {
        fieldName: "ulysesCloudProxyClientKey",
        displayName: "Ulyses Cloud - PCI Proxy key",
        helpText: "Key del cliente para el PCI Proxy",
        widget: "input",
      },
      {
        displayName: "GTM",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "externalHotelId",
        displayName: "External hotel id",
        helpText:
          "Identificador único externo a Witbooking asociado a este establecimiento para uso en GTM",
        widget: "input",
      },
      {
        displayName: "Combinador de tarifas",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "hasRoomCombinationByLock",
        displayName: "Combinador por bloqueos",
        description: "Permite activar la combinación de tarifas por bloqueo",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "preventRestrictiveRateCombinations",
        description: "Aplicar siempre la tarifa más restrictiva",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Motor de reservas",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "promotionsListMode",
        displayName: "Widget de promos en mobile",
        description: "Modalidad en la que se mostrara el listado de promociones en mobile",
        widget: "selector",
        optionDisplay: {
          ICON_BUTTON: {
            label: "Botón ícono",
          },
          SLIDESHOW: {
            label: "Carousel",
          },
        },
        defaultValue: "ICON_BUTTON",
      },
      {
        fieldName: "showEnginePrices",
        widget: "checkbox",
        description: "Mostrar precios en el motor",
        helpText:
          "SOLO DESACTIVAR EN AGRS. Al desmarcar este check, el motor NO mostrará ningún precio",
        defaultValue: true,
      },
      {
        fieldName: "showEngineDiscount",
        widget: "checkbox",
        description: "Mostrar descuentos en el motor",
        helpText:
          "SOLO DESACTIVAR EN AGRS. Al desmarcar este check, el motor NO mostrará ningún descuentos",
        defaultValue: true,
      },
      {
        fieldName: "activeAbandonmentCart",
        displayName: "Activar email de abandono de carrito - LOYALTY",
        widget: "checkbox",
        description: "Activar email de abandono de carrito - LOYALTY",
        defaultValue: false,
      },
      {
        fieldName: "activeAbandonmentCartNotLoyalty",
        displayName: "Activar email de abandono de carrito - SIN LOYALTY",
        widget: "checkbox",
        description: "Activar email de abandono de carrito - SIN LOYALTY",
        defaultValue: false,
      },
      {
        fieldName: "engineVersion",
        displayName: "Versión del motor",
        description: "",
        widget: "selector",
        optionDisplay: {
          "21": {
            label: "V21",
          },
          "17": {
            label: "V17",
          },
        },
        defaultValue: "17",
      },
      {
        fieldName: "v21Status",
        displayName: "Regen de cache de v21",
        description: "",
        widget: "selector",
        optionDisplay: {
          DISABLED: {
            label: "Desactivado",
          },
          ENABLED: {
            label: "Activo",
          },
        },
        defaultValue: "DISABLED",
      },
      {
        fieldName: "isRegenCacheActive",
        displayName: "Activar Regen de cache de motor",
        widget: "checkbox",
        description: "Activar Regen de cache de motor",
        helpText:
          "Al cambiar algo en BO, el regen cache solo ocurre en motores LIVE. Este param permite activar el regen de cache para aquellos motores que NO estan live (demo, prog, etc)",
        defaultValue: true,
      },
      {
        fieldName: "abTestActive",
        widget: "checkbox",
        description: "Activar Test A/B",
        helpText:
          "<div>ACTIVAR SOLO SI se cumplen las siguientes condiciones:</div> 1. V21 es funcional para este motor<br/> 2. La versión del motor es v17<br/> 3. Regen cache de v21 está activo.",
        defaultValue: false,
      },
      {
        fieldName: "propertyAnalyticsId",
        displayName: "Property analytics id",
        helpText:
          "Identificador único externo a Witbooking asociado a este establecimiento para uso en el data layer del motor de reservas",
        widget: "input",
      },
      {
        fieldName: "keepMultiConfigOnRedirect",
        widget: "checkbox",
        defaultValue: true,
      },
      {
        displayName: "Loyalty",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "defaultBrand",
        displayName: "Default Brand",
        description: "",
        widget: "selector",
        optionDisplay: {}, //this value is setting from controller
        defaultValue: "",
      },
      {
        fieldName: "enableLoyalty",
        displayName: "Activar Loyalty",
        description:
          "Permite activar los componentes de loyalty en el motor de reservas. Si se desactiva, no saldrá el precio gancho, el icono de login, ni los enlaces de registro en el motor",
        widget: "checkbox",
        defaultValue: true,
      },
      {
        fieldName: "showLoyaltyPromotedDiscount",
        displayName: "Mostrar precio gancho loyalty",
        description:
          "Si este parametro no está activo, no se mostrará el precio gancho en el motor, AUN si la brand tiene un promotedTier configurado",
        widget: "checkbox",
        defaultValue: true,
      },
      {
        displayName: "Canal B2B",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "b2bChannelEnabled",
        displayName: "Canal B2B",
        description:
          "Activar el canal B2B: condiciones comerciales y los campos B2B de la ficha de organización, en solo lectura (actualmente solo para Sercotel)",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "b2bMasterModeEnabled",
        displayName: "Modo máster B2B",
        description:
          "Permite editar y borrar las condiciones comerciales y editar las organizaciones B2B desde el backoffice. Déjalo desactivado donde Salesforce publique los datos: su siguiente envío reemplaza lo editado aquí",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Gestión",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "showAltARIManagerStyles",
        displayName: "Mostrar estilos alternativos en gestión",
        description:
          "Si este parámetro está activo aplicará una serie de cambios en la pantalla de gestión (fines de semana en azul, valores de madres en negrita, etc)",
        widget: "checkbox",
        defaultValue: true,
      },
      {
        fieldName: "numberOfDaysARIManager",
        displayName: "Días mostrados en gestión",
        helpText: "Esto solo aplicará si están activos los estilos alternativos",
        widget: "selector",
        optionDisplay: Object.fromEntries(
          Array.from({ length: MAX_DAYS_IN_ARI_MANAGER - MIN_DAYS_IN_ARI_MANAGER + 1 }, (_, i) => [
            MIN_DAYS_IN_ARI_MANAGER + i,
            { label: (MIN_DAYS_IN_ARI_MANAGER + i).toString() },
          ])
        ),
        defaultValue: 14,
      },
      {
        displayName: "Módulo de grupos",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "showGroupBookingModule",
        description: "Activar módulo de reservas grupales",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Tienda Online",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "onlineStoreActive",
        description: "Activar tienda online",
        helpText: "Una vez activo, se habilitarán los menús de tienda en el Backoffice",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "onlineStorePublished",
        description: "Publicar tienda online",
        helpText:
          "Modo LIVE de tienda. Se activa el regen, se elimina el badge de demo y se habilita el botón en el menú del motor",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "onlineStoreHideNavbarButton",
        description: "Ocultar botón de tienda online",
        helpText:
          "Si está activo se ocultará el botón de tienda en el navbar del motor de reservas",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "onlineStoreCustomDomain",
        displayName: "Dominio personalizado de la tienda online",
        widget: "input",
        defaultValue: "",
      },
      {
        fieldName: "onlineStoreMode",
        displayName: "Modo tienda",
        widget: "selector",
        optionDisplay: {
          inventory_lines: {
            label: "Lineas de inventario",
          },
          price_table: {
            label: "Tabla de precios",
          },
        },
        defaultValue: "price_table",
      },
      {
        fieldName: "onlineStoreExpirationDays",
        displayName: "Tiempo en días de expiración productos",
        helpText:
          "Indica el numero de días tras los cuales un producto expirará, cada producto puede tener un valor distinto",
        widget: "input",
        defaultValue: "365",
      },
      {
        fieldName: "onlineStoreStayExtensionDays",
        displayName: "Margén de estancia adicional para productos con estancia",
        helpText:
          "Días adicionales tras la validez del bono en los que el cliente aún puede disfrutar de su estancia. Si es 0, la estancia debe finalizar dentro del periodo de validez.",
        widget: "input",
        defaultValue: "0",
      },
      {
        displayName: "Webcamp",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "useWebcampIntegration",
        description: "Utilizar integración con Webcamp",
        helpText: "Si está activo se utilizará Webcamp para la gestión de disponibilidad",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Cotización",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "isQuotationActive",
        description: "Activar módulo de cotización",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Orquestador",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "isOrchestratorActive",
        description: "Activar Orquestador",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "isOrchestratorTestAbActive",
        description: "Activar Test A/B del Orquestador",
        helpText:
          "Muestra el módulo Test A/B dentro del Orquestador. Requiere el Orquestador activo. No confundir con el Test A/B de versiones del motor.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "WhatsApp Concierge",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "isWhatsAppConciergeActive",
        description: "Activar WhatsApp Concierge",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        displayName: "Maarlab (Vuelo + Hotel)",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "isMaarlabActive",
        description: "Activar integración con Maarlab",
        helpText:
          "Habilita el flujo Vuelo + Hotel. Requiere que el hotel esté dado de alta " +
          "en el backoffice de Maarlab y tener una API key de tipo UPSELLING.",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "maarlabApiKey",
        displayName: "Maarlab UPSELLING API key",
        helpText:
          "API key de tipo UPSELLING generada en el backoffice de Maarlab. " +
          "Autentica todas las llamadas del back. No se expone nunca al cliente.",
        widget: "input",
      },
      {
        fieldName: "maarlabEnvironment",
        displayName: "Entorno Maarlab",
        widget: "selector",
        optionDisplay: {
          test: { label: "Test" },
          production: { label: "Producción" },
        },
        defaultValue: "test",
      },
      {
        displayName: "Extras con categorías",
        widget: "subsection",
        defaultValue: false,
      },
      {
        fieldName: "extrasCategoriesActive",
        description: "Activar Extras con categorías",
        helpText:
          "Habilita en esta propiedad las categorías de extra (Vehículo, Instalaciones): límites e incluidos por tipología de alojamiento, cobro solo de lo que excede lo incluido y matrícula por vehículo. Desactivado, los extras se venden como siempre; lo configurado se conserva y vuelve a aplicarse al reactivarlo.",
        widget: "checkbox",
        defaultValue: false,
      },
    ],
  },
  validation: {
    b2bChannelEnabled: {
      type: "Boolean",
      constraints: {},
    },
    b2bMasterModeEnabled: {
      type: "Boolean",
      constraints: {},
    },
    // Maarlab documents no format for the UPSELLING key, so the only client-side rule is a
    // length cap to stop a paste accident. See US-001 RQ3.
    maarlabApiKey: {
      type: "String",
      constraints: {
        length: { maximum: 1024 },
      },
    },
    useCustomEmailTemplate: {
      type: "Boolean",
      constraints: {},
    },
    showEmailTemplateManager: {
      type: "Boolean",
      constraints: {},
    },
    showAdvancedEmailsManager: {
      type: "Boolean",
      constraints: {},
    },
    newEmailConfig: {
      type: "Boolean",
      constraints: {},
    },
    showDisplayManager: {
      type: "Boolean",
      constraints: {},
    },
    showAdvancedConditionsManagers: {
      type: "Boolean",
      constraints: {},
    },
    showAdvancedMealplanManagers: {
      type: "Boolean",
      constraints: {},
    },
    showPromotionsManager: {
      type: "Boolean",
      constraints: {},
    },
    showServicesManager: {
      type: "Boolean",
      constraints: {},
    },
    showFiltersManager: {
      type: "Boolean",
      constraints: {},
    },
    showPackagesManager: {
      type: "Boolean",
      constraints: {},
    },
    showNewReservationModification: {
      type: "Boolean",
      constraints: {},
    },
    showInventoryMultiUpdate: {
      type: "Boolean",
      constraints: {},
    },
    showInventoryTable: {
      type: "Boolean",
      constraints: {},
    },
    showBatchInventories: {
      type: "Boolean",
      constraints: {},
    },
    enableAutomaticCharges: {
      type: "Boolean",
      constraints: {},
    },
    propertyImageLimit: {
      type: "Number",
      constraints: {},
    },
    hasOneRateChild: {
      type: "Boolean",
      constraints: {},
    },
    compoundDiscounts: {
      type: "Boolean",
      constraints: {},
    },
    hasPremiumMap: {
      type: "Boolean",
      constraints: {},
    },
    showAltARIManagerStyles: {
      type: "Boolean",
      constraints: {},
    },
    showGroupBookingModule: {
      type: "Boolean",
      constraints: {},
    },
    isQuotationActive: {
      type: "Boolean",
      constraints: {},
    },
    isOrchestratorActive: {
      type: "Boolean",
      constraints: {},
    },
    extrasCategoriesActive: {
      type: "Boolean",
      constraints: {},
    },
    isOrchestratorTestAbActive: {
      type: "Boolean",
      constraints: {},
    },
    showNewReservationsList: {
      type: "Boolean",
      constraints: {},
    },
    splitReservationQuantityAsRoomStays: {
      type: "Boolean",
      constraints: {},
    },
    stickyBookingForm: {
      type: "Boolean",
      constraints: {},
    },
    showOccupationAlternativesManager: {
      type: "Boolean",
      constraints: {},
    },
    allowMultipleMealPlans: {
      type: "Boolean",
      constraints: {},
    },
    showMultipleAccommodations: {
      type: "Boolean",
      constraints: {},
    },
    showNewBookingForm: {
      type: "Boolean",
      constraints: {},
    },
    showCancellationTable: {
      type: "Boolean",
      constraints: {},
    },
    showHistoricalReservations: {
      type: "Boolean",
      constraints: {},
    },
    hotelVerseActive: {
      type: "Boolean",
      constraints: {},
    },
    keepMultiConfigOnRedirect: {
      type: "Boolean",
      constraints: {},
    },
    showEnginePrices: {
      type: "Boolean",
      constraints: {},
    },
    showEngineDiscount: {
      type: "Boolean",
      constraints: {},
    },
    allowCustomerCommentEdit: {
      type: "Boolean",
      constraints: {},
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
